<template>
  <vue-modal
    :show-modal="showModal"
    :primary-footer-button-translation="$t('pages.payroll.download')"
    :centered="true"
    :showPrimaryFooterButton="false"
    :showSecondaryFooterButton="false"
    @[closeEvent]="onCloseButtonClicked"
    @[secondaryEvent]="onCloseButtonClicked"
  >
    <template #body>
      <info-component :message="message" :type="modalType"></info-component>
    </template>
  </vue-modal>
</template>

<script>
import VueModal, {
  CLOSE_BUTTON_CLICKED_MODAL_EVENT,
  PRIMARY_BUTTON_CLICKED_MODAL_EVENT,
  SECONDARY_BUTTON_CLICKED_MODAL_EVENT,
} from "@/components/modal";

import InfoComponent, { SUCCESS_TYPE_INFO_COMPONENT } from "@/pages/components/info";

import { SHOW_SUCCESS_INFO_MODAL } from "./index";

export default {
  components: {
    VueModal,
    InfoComponent,
  },
  data() {
    return {
      showModal: false,
      message: "",
    };
  },
  created() {
    EventBus.listen(SHOW_SUCCESS_INFO_MODAL, ({ message }) => {
      this.message = message;
      this.showModal = true;
    });
  },
  beforeDestroy() {
    EventBus.off(SHOW_SUCCESS_INFO_MODAL);
  },
  computed: {
    saveEvent() {
      return PRIMARY_BUTTON_CLICKED_MODAL_EVENT;
    },
    secondaryEvent() {
      return SECONDARY_BUTTON_CLICKED_MODAL_EVENT;
    },
    closeEvent() {
      return CLOSE_BUTTON_CLICKED_MODAL_EVENT;
    },
    modalType() {
      return SUCCESS_TYPE_INFO_COMPONENT;
    },
  },
  methods: {
    onCloseButtonClicked() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped></style>
